<template>
  <div class="order_page">
    <b-breadcrumb :items="breadCrumbs" />
    <div class="row" v-if="order">
      <div class="col-lg-4 col-md-6 col-12">
        <b-card
          header="Customer Details"
          header-text-variant="white"
          header-tag="header"
          header-bg-variant="primary"
          footer-bg-variant="success"
          footer-border-variant="dark"
        >
          <table class="table table-striped">
            <tbody>
              <tr>
                <td>ID</td>
                <td>{{ order.customer_id }}</td>
              </tr>
              <tr>
                <td>First name</td>
                <td>{{ order.firstname }}</td>
              </tr>
              <tr>
                <td>Last name</td>
                <td>{{ order.lastname }}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>{{ order.email }}</td>
              </tr>
              <tr>
                <td>Telephone</td>
                <td>{{ order.telephone }}</td>
              </tr>
              <tr>
                <td>Fax</td>
                <td>{{ order.fax }}</td>
              </tr>
            </tbody>
          </table>
        </b-card>
        <b-card
          header="Payment Details"
          header-text-variant="white"
          header-tag="header"
          header-bg-variant="primary"
          footer-bg-variant="success"
          footer-border-variant="dark"
        >
          <table class="table table-striped">
            <tbody>
              <tr>
                <td>First name</td>
                <td>{{ order.payment_firstname }}</td>
              </tr>
              <tr>
                <td>Last name</td>
                <td>{{ order.payment_lastname }}</td>
              </tr>
              <tr>
                <td>Company</td>
                <td>{{ order.payment_company }}</td>
              </tr>
              <tr>
                <td>Address Line 1</td>
                <td>{{ order.payment_address_1 }}</td>
              </tr>
              <tr>
                <td>Address Line 2</td>
                <td>{{ order.payment_address_2 }}</td>
              </tr>
              <tr>
                <td>City</td>
                <td>{{ order.payment_city }}</td>
              </tr>
              <tr>
                <td>County</td>
                <td>{{ order.payment_county }}</td>
              </tr>
              <tr>
                <td>Country</td>
                <td>{{ order.payment_country }}</td>
              </tr>
              <tr>
                <td>Postcode</td>
                <td>{{ order.payment_postcode }}</td>
              </tr>
              <tr>
                <td>Method</td>
                <td>{{ order.payment_method }}</td>
              </tr>
            </tbody>
          </table>
        </b-card>
        <b-card
          header="Shipping Details"
          header-text-variant="white"
          header-tag="header"
          header-bg-variant="primary"
          footer-bg-variant="success"
          footer-border-variant="dark"
        >
          <table class="table table-striped">
            <tbody>
              <tr>
                <td>First name</td>
                <td>{{ order.shipping_firstname }}</td>
              </tr>
              <tr>
                <td>Last name</td>
                <td>{{ order.shipping_lastname }}</td>
              </tr>
              <tr>
                <td>Company</td>
                <td>{{ order.shipping_company }}</td>
              </tr>
              <tr>
                <td>Address Line 1</td>
                <td>{{ order.shipping_address_1 }}</td>
              </tr>
              <tr>
                <td>Address Line 2</td>
                <td>{{ order.shipping_address_2 }}</td>
              </tr>
              <tr>
                <td>City</td>
                <td>{{ order.shipping_city }}</td>
              </tr>
              <tr>
                <td>County</td>
                <td>{{ order.shipping_county }}</td>
              </tr>
              <tr>
                <td>Country</td>
                <td>{{ order.shipping_country }}</td>
              </tr>
              <tr>
                <td>Postcode</td>
                <td>{{ order.shipping_postcode }}</td>
              </tr>
              <tr>
                <td>Method</td>
                <td>{{ order.shipping_method }}</td>
              </tr>
            </tbody>
          </table>
        </b-card>
      </div>
      <div class="col-lg-8 col-md-6 col-12">
        <b-alert show variant="warning" v-if="!order.complete"
          >Order is Partially Picked</b-alert
        >
        <div class="row">
          <div class="col-12">
            <router-link
              class="btn btn-info float-right mb-2"
              v-if="order.order_status_id == 2"
              :to="{ name: 'picking', params: { id: order.order_id } }"
              >Pick</router-link
            >
          </div>
        </div>
        <b-card
          header="Order Details"
          header-text-variant="white"
          header-tag="header"
          header-bg-variant="primary"
          footer-bg-variant="success"
          footer-border-variant="dark"
        >
          <table class="table table-striped">
            <tbody>
              <tr>
                <td>Date</td>
                <td>{{ order.date_added }}</td>
              </tr>
              <tr>
                <td>Status</td>
                <td
                  :class="{
                    warning: order.order_status_name == 'Processing',
                    success: order.order_status_name == 'Shipped'
                  }"
                >
                  {{ order.order_status_name }}
                </td>
              </tr>
            </tbody>
          </table>
        </b-card>
        <b-card
          header="Order Items"
          header-text-variant="white"
          header-tag="header"
          header-bg-variant="primary"
          footer-bg-variant="success"
          footer-border-variant="dark"
        >
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Product</th>
                <th>Model</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr :key="item.order_product_id" v-for="item in order.items">
                <td>{{ item.name }}</td>
                <td>{{ item.model }}</td>
                <td>{{ item.quantity }}</td>
                <td>
                  {{
                    order.currency.symbol_left +
                      (
                        Math.round(item.price * order.currency_value * 100) /
                        100
                      ).toFixed(2) +
                      order.currency.symbol_right
                  }}
                </td>
                <td>
                  {{
                    order.currency.symbol_left +
                      (
                        Math.round(item.total * order.currency_value * 100) /
                        100
                      ).toFixed(2) +
                      order.currency.symbol_right
                  }}
                </td>
              </tr>
              <tr :key="total.order_total_id" v-for="total in order.totals">
                <td colspan="4" align="right">{{ total.title }}</td>
                <td colspan="1">
                  {{
                    order.currency.symbol_left +
                      (
                        Math.round(total.value * order.currency_value * 100) /
                        100
                      ).toFixed(2) +
                      order.currency.symbol_right
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "order",
  components: {},
  data() {
    return {
      order: null,
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Orders", to: { name: "orders" } },
        { text: "Order", active: true }
      ]
    };
  },
  mounted: function() {
    this.getOrder();
  },
  methods: {
    getOrder: function() {
      let loader = this.$loading.show();
      this.$http
        .get(this.APIURL + this.BRAND + "/order/" + this.$route.params.id)
        .then(
          response => {
            this.order = response.data;
            loader.hide();
          },
          error => {
            this.loading = false;
            loader.hide();
            console.log(error);
          }
        );
    }
  }
};
</script>
<style scoped>
.card-body {
  padding: 0px;
}
.card {
  margin-bottom: 10px;
}
</style>
